// @flow
import * as Sentry from '@sentry/react';
import { startConversationReadClient, closeWebsocketConnection, createNewConversation } from '../conversation';

import { fetchTrainingFiles } from '../config';
import { fetchScribeSettings } from '../firebase';

import { fetchAvaWebAppSession } from './index';
import { logoutAndClean } from '../../utils/user';
import { getSocketIfExist } from '../../utils/getSocket';

export const initiateSession = (history: any, options: Object = {}) => async (
  dispatch: Function,
  getState: Function
): Promise<void> => {
  try {
    dispatch({ type: 'LOADING_APP', status: true });

    const {
      scribeSession: { features, branchId, captioner, needInternalAudioAccess, microphoneAccess, showQuickSetup },
      scribeConversation: { token },
    } = getState();
    const request = localStorage.getItem('ava_request');
    let { search } = history.location;
    let path;

    if (features.scribe && !window.isElectron && !token && !branchId && !request) {
      path = '/web/scribe-dashboard';
      search = '';
    } else {
      path = '/web/transcript';
    }

    const socket = getSocketIfExist();
    if (!captioner || !(socket && socket.v1)) {
      await closeWebsocketConnection()(dispatch, getState);
      await fetchAvaWebAppSession(options)(dispatch, getState);
    }
    startConversationReadClient()(dispatch, getState);
    // Purposefully ignoring promise, as we only care about side effects.
    fetchScribeSettings()(dispatch, getState);
    if (features.scribe) {
      await fetchTrainingFiles()(dispatch);
    }
    dispatch({ type: 'LOADING_APP', status: false });
    if (window.electronIPC) {
      window.electronIPC.sendDoneLoading();
    }
    if (options.startConvo && !needInternalAudioAccess && microphoneAccess === 'granted' && !showQuickSetup) {
      await createNewConversation()(dispatch, getState);
    }
    if (path) {
      history.push(`${path}${search}`);
    }
  } catch (err) {
    Sentry.captureException(err);
    // eslint-disable-next-line
    alert(
      'Ava faced an unexpected error. We will reload the page to get it fixed. Please contact support@ava.me if the issue persist.'
    );
    if (window.location.href.startsWith('https://web.ava.me')) {
      await logoutAndClean();
      window.open('/', '_self');
    }
  }
};
